"use client";

import { Mentor } from "@/services/types";
import Image from "next/image";
import React, { ReactNode } from "react";
const StatsCard5 = ({
  title,
  subtitle,
  icon,
  gridStyle,
  instructorsData
}: {
  title: string;
  subtitle: string;
  icon: ReactNode;
  gridStyle: {
    gridRow: string;
    gridColumn: string;
  };
  instructorsData: Mentor[];
}) => {
  if (instructorsData.length === 0) {
    return null;
  }
  return <div className="stats-section-card--5" style={gridStyle} data-sentry-component="StatsCard5" data-sentry-source-file="StatsCard5.tsx">
      <div className="stats-section-card--5--text">
        <div className="stats-section-card--title">
          {title}
        </div>
        <div className="stats-section-card--subtitle">
          {subtitle}
        </div>
      </div>
      <div className="marquee">
        <div className="mentors" style={{
        animation: `scroll-left ${instructorsData.length * 2}s linear infinite`,
        WebkitAnimation: `scroll-left ${instructorsData.length * 2}s linear infinite`
      }}>
          {instructorsData.map((item, index) => <div className="mentor-card">
              <Image className="mentor-image" src={item.attributes.mentorImage.data?.attributes.url || ""} alt="mentor" width={98} height={98} />

              <div className="mentor-details">
                <div className="mentor-name">{item.attributes.name}</div>
                <div className="mentor-designation">{item.attributes.designation}</div>
              </div>
            </div>)}
        </div>
        <div className="mentors" style={{
        animation: `scroll-left ${instructorsData.length * 2}s linear infinite`,
        WebkitAnimation: `scroll-left ${instructorsData.length * 2}s linear infinite`
      }}>
          {instructorsData.map((item, index) => <div className="mentor-card">
              <Image className="mentor-image" src={item.attributes.mentorImage.data?.attributes.url || ""} alt="mentor" width={98} height={98} />

              <div className="mentor-details">
                <div className="mentor-name">{item.attributes.name}</div>
                <div className="mentor-designation">{item.attributes.designation}</div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default StatsCard5;